var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('text-editor',{model:{value:(_vm.topContent),callback:function ($$v) {_vm.topContent=$$v},expression:"topContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }